<script setup>
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'

import { useRoute } from 'vue-router/dist/vue-router'
import { useProjectUserStore } from '@/stores/project_user'
import { useProjectStore } from '@/stores/project'
import _ from 'lodash'
import { useAuthorizationStore } from '@/stores/authorization'
import ProjectSideBar from '@/components/project-detail/ProjectSideBar.vue'
import { AppBackground, ProjectHeaderImage } from '@haskoning/vue-component-library'

const route = useRoute()

const projectStore = useProjectStore()
const projectUserStore = useProjectUserStore()
const authorizationStore = useAuthorizationStore()

const { items: authorizations } = storeToRefs(authorizationStore)
const { currentItem: currentProject } = storeToRefs(useProjectStore())
const { currentItem: currentProjectUser } = storeToRefs(projectUserStore)

onMounted(async () => {
  await projectUserStore.fetchItems({ project: route.params.id })
  projectUserStore.setCurrentItem()
  if (authorizations.value.length === 0) {
    await authorizationStore.fetchItems()
  }
  authorizationStore.setCurrentRole([currentProjectUser.value.role])
  if (!currentProject.value || _.isEmpty(currentProject.value)) {
    await projectStore.fetchItem(route.params.id)
  }
})
</script>
<template>
  <div style="display: flex; flex-direction: column" class="fill-height">
    <ProjectHeaderImage :lazy-src="'/header_lazy.jpg'" :src="'/header.jpeg'" />
    <AppBackground>
      <ProjectSideBar />
      <router-view></router-view>
    </AppBackground>
  </div>
</template>
